import * as React from "react";
import { Edit } from "@mui/icons-material";
import { SubTransactionForm } from "./SubTransactionForm";
import { ISubTransaction } from "./SubTransactionsField";

interface IEditActionProps {
    value: ISubTransaction;
    onChange(value: ISubTransaction): void;
}

export const EditAction = ({value, onChange}: IEditActionProps) => {
    return (
        <SubTransactionForm
            title="Edit sub transaction"
            value={value}
            onChange={onChange}
            trigger={<Edit sx={{fontSize: 18}} />}
        />
    );    
};
